/*
 * Filter value groups (owner, 2026-10-30). The theme renders values that mean the same (same colour in any language,
 * or the same text with other capitals/spaces/punctuation) as one row on the server (snippets/filter-group-key.liquid,
 * snippets/collection-filters.liquid); the other spellings are hidden inputs in that row. This script only:
 *  - ticks/unticks those hidden inputs together with the visible checkbox, before the theme reads the form;
 *  - merges active filter chips of the same group and makes the remaining chip remove every spelling.
 */
(() => {
  document.addEventListener('input', (event) => {
    const box = event.target;
    if (!box.matches || !box.matches('input[data-fg-group]')) return;
    box.closest('label')?.querySelectorAll('input[data-fg-alias]').forEach((alias) => { alias.checked = box.checked; });
  }, true);

  function groupChips(root) {
    const seen = new Map();
    root.querySelectorAll('a.collection-filter-button[data-param][data-gk]').forEach((a) => {
      const key = a.dataset.param + '|' + a.dataset.gk;
      const main = seen.get(key);
      if (!main) { seen.set(key, a); return; }
      const box = a.closest('facet-remove');
      if (box) box.hidden = true;
      const url = new URL(main.href, location.origin);
      const keep = url.searchParams.getAll(main.dataset.param).filter((v) => v !== a.dataset.value);
      url.searchParams.delete(main.dataset.param);
      keep.forEach((v) => url.searchParams.append(main.dataset.param, v));
      main.href = url.pathname + url.search;
    });
  }
  groupChips(document);
  new MutationObserver((records) => {
    if (records.some((r) => r.addedNodes.length)) groupChips(document);
  }).observe(document.body, { childList: true, subtree: true });
})();
